export interface IValidationError {
    index: number,
    messages: string[]
}